module.exports = __webpack_public_path__ + "img/nogetwater.29f3951e.png";